import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ProgressCircle } from 'react-native-svg-charts';
import { s } from 'react-native-wind';
import { Config } from '../../../config';
import { Description } from '../../../components';

interface KpiGaugeChartProps {
  title: string;
  score: number;
  maxScore?: number;
}

export const KpiGaugeChart: React.FC<KpiGaugeChartProps> = ({
  title,
  score,
  maxScore = 4,
}) => {
  // Calculate progress (0-1 range)
  const progress = score / maxScore;

  // Determine color based on score
  const getColor = () => {
    if (progress <= 0.4) return '#FF4D4F'; // Red for low scores
    if (progress < 0.75) return '#FAAD14'; // Yellow for medium-low scores
    else return '#52C41A'; // Light green for medium-high scores
    // return '#1890FF'; // Blue for high scores
  };

  return (
    <View style={styles.container}>
      <View style={styles.chartContainer}>
        <ProgressCircle
          style={styles.chart}
          progress={progress}
          progressColor={getColor()}
          backgroundColor={Config.colorCard}
          strokeWidth={10}
        />
        <View style={styles.scoreContainer}>
          <Text style={styles.scoreText}>{score.toFixed(1)}</Text>
          <Text style={styles.maxScoreText}>/ {maxScore}</Text>
        </View>
      </View>
      <Description style={s`text-center mt-2 px-2 text-xs flex-wrap`}>
        {title}
      </Description>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginVertical: 8,
    width: 100,
  },
  chartContainer: {
    position: 'relative',
    width: 80,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
  chart: {
    height: 80,
    width: 80,
  },
  scoreContainer: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  scoreText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Config.colorTextPrimary,
  },
  maxScoreText: {
    fontSize: 12,
    color: Config.colorTextSecondary,
    marginTop: 2,
  },
});
